import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function SmallSelectPlaceholder({
  items = [],
  setSelectItem,
  chosen,
  setChosen,
  fullWidth = false,
}) {
  const width = fullWidth ? "100%" : "100%";

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectItem(true);
    setChosen(value);
  };

  const selectedItem = items.find(
    (item) => item.key === chosen || String(item.key) === String(chosen)
  );

  return (
    <FormControl
      sx={{
        width,
        minWidth: 0,
        border: "1px solid #B9B9B9",
        borderRadius: "12px",
        backgroundColor: "#fff",
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        "& .MuiSelect-select": {
          fontFamily: "IRANSansBold",
          fontSize: "14px",
          padding: "10px 12px",
        },
        "& .MuiSvgIcon-root": {
          color: "#000",
        },
      }}
    >
      <Select
        displayEmpty
        value={chosen === null || chosen === undefined ? "" : chosen}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={(selected) => {
          if (selected === "" || selected === null || selected === undefined) {
            return (
              <span
                style={{
                  color: "#B9B9B9",
                  fontFamily: "IRANSanslight",
                  fontSize: "14px",
                }}
              >
                انتخاب کنید
              </span>
            );
          }
          return selectedItem ? selectedItem.value : selected;
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 220,
              borderRadius: "12px",
              marginTop: "4px",
            },
          },
        }}
      >
        {items.map((name, index) => (
          <MenuItem
            sx={{
              fontFamily: "IRANSansBold",
              fontSize: "14px",
            }}
            key={index}
            value={name.key}
          >
            {name.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
